// src/config.js
const SHEET_ID = process.env.REACT_APP_SHEET_ID || '1qfCQnJkj-h51TdiCVWcRWmrtBdL0chW1';

export const config = {
  SHEET_ID: '1_MamzaK19Mal_98qJjke6A-9WiDfIrVA', // Main inventory sheet
  DOA_SHEET_ID: '1GYxBV_IeCKcZfRIcF01MbSkZEW9uhJPG', // DOA items sheet
  
  // Digital Twin Version: 'digitaltwin' or 'digitaltwin1'
  // Set via environment variable: REACT_APP_DIGITAL_TWIN_VERSION
  DIGITAL_TWIN_VERSION: process.env.REACT_APP_DIGITAL_TWIN_VERSION || 'digitaltwin',
};

export default config;